<adapt-dialog [maxWidth]="dialogWidth"
              [showHelpButton]="false"
              [expandable]="hasRichText"
              [fitHeight]="isTwoColumnLayout">
    <h3 adapt-dialog-title>
        {{ data.title }}
        @if (data.tooltip) {
            <i class="fal fa-info-circle"
               adaptTooltip="{{ data.tooltip }}"></i>
        }
    </h3>
    <div adapt-dialog-content
         class="h-100 d-flex flex-column">
        <div [ngClass]="{
                'd-flex flex-column flex-lg-row gap-3': !!data.articleId,
            }"
             class="overall-container">
            @if (data.articleId) {
                <div class="guidance-column"
                     [adaptCollapsible]="data.articleId"
                     [ngClass]="{ 'guidance-column': !!data.articleId }">
                    <adapt-styled-implementation-kit [articleId]="data.articleId"
                                                     contentStyle="embedded"></adapt-styled-implementation-kit>
                </div>
            }

            <div [ngClass]="{ 'content-column': !!data.articleId }"
                 class="content">
                @for (element of data.entities; track element; let i = $index) {
                    <div class="d-flex flex-column flex-grow-1"
                         [ngStyle]="getElementStyle(i)">
                        @if (element.label) {
                            <label>{{ element.label }}</label>
                        }
                        @if (isRichTextEdit(element)) {
                            <adapt-html-editor [forceSize]="dialogWidth <= 650 || !!data.articleId ? 'compact' : 'standard'"
                                               [(contents)]="element.entity[element.fieldName]"
                                               (isValidChange)="element.isEditorValid = $event"
                                               #focus></adapt-html-editor>
                        }
                        @if (isTextEdit(element)) {
                            <dx-text-box [(value)]="element.entity[element.fieldName]"
                                         [maxLength]="element.maxLength ? element.maxLength : 0"
                                         #focus>
                                <dx-validator>
                                    @for (customValidator of element.customValidators; track customValidator) {
                                        <dxi-validator-validation-rule type="custom"
                                                                       [validationCallback]="customValidator.validator"
                                                                       [message]="customValidator.message"></dxi-validator-validation-rule>
                                    }
                                    @if (element.usePropertyValidator) {
                                        <dxi-validator-validation-rule [adaptEntity]="element.entity"
                                                                       [adaptEntityProperty]="element.fieldName"></dxi-validator-validation-rule>
                                    }
                                </dx-validator>
                            </dx-text-box>
                        }
                        @if (isTextAreaEdit(element)) {
                            <dx-text-area [(value)]="element.entity[element.fieldName]"
                                          [maxLength]="element.maxLength ? element.maxLength : 0"
                                          [height]="100">
                                <dx-validator>
                                    @for (customValidator of element.customValidators; track customValidator) {
                                        <dxi-validator-validation-rule type="custom"
                                                                       [validationCallback]="customValidator.validator"
                                                                       [message]="customValidator.message"></dxi-validator-validation-rule>
                                    }
                                    @if (element.usePropertyValidator) {
                                        <dxi-validator-validation-rule [adaptEntity]="element.entity"
                                                                       [adaptEntityProperty]="element.fieldName"></dxi-validator-validation-rule>
                                    }
                                </dx-validator>
                            </dx-text-area>
                        }
                        @if (isCountryEdit(element)) {
                            <adapt-select-country [(country)]="element.entity[element.fieldName]"></adapt-select-country>
                        }
                        @if (isDateEdit(element)) {
                            <dx-date-box type="date"
                                         [(value)]="element.entity[element.fieldName]">
                                <dx-validator>
                                    @for (customValidator of element.customValidators; track customValidator) {
                                        <dxi-validator-validation-rule type="custom"
                                                                       [validationCallback]="customValidator.validator"
                                                                       [message]="customValidator.message"></dxi-validator-validation-rule>
                                    }
                                    @if (element.usePropertyValidator) {
                                        <dxi-validator-validation-rule [adaptEntity]="element.entity"
                                                                       [adaptEntityProperty]="element.fieldName"></dxi-validator-validation-rule>
                                    }
                                </dx-validator>
                            </dx-date-box>
                        }
                        @if (isSelectEdit(element)) {
                            <dx-select-box displayExpr="text"
                                           valueExpr="value"
                                           [dataSource]="element.selectValues"
                                           [(value)]="element.entity[element.fieldName]"
                                           [showClearButton]="element.selectOptional">
                                <dx-validator>
                                    @for (customValidator of element.customValidators; track customValidator) {
                                        <dxi-validator-validation-rule type="custom"
                                                                       [validationCallback]="customValidator.validator"
                                                                       [message]="customValidator.message"></dxi-validator-validation-rule>
                                    }
                                    @if (element.usePropertyValidator) {
                                        <dxi-validator-validation-rule [adaptEntity]="element.entity"
                                                                       [adaptEntityProperty]="element.fieldName"></dxi-validator-validation-rule>
                                    }
                                </dx-validator>
                            </dx-select-box>
                        }
                    </div>
                }
            </div>
        </div>

        @if (saveError) {
            <div role="alert"
                 class="alert alert-danger mt-3">
                {{ saveError }}
            </div>
        }
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveBlockingClick]="saveAndClose"
                                   [saveIsDisabled]="hasValidationErrors"
                                   (cancelClick)="cancel()"> </adapt-standard-dialog-buttons>
</adapt-dialog>
